import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageHomeComponent implements OnInit {
    public password: string = '';
    public error: string = '';
    public unlocked: boolean = false;
    public loading: boolean = false;

    constructor(@Inject( ChangeDetectorRef) public ref: ChangeDetectorRef) { }

    public async ngOnInit() { }

    private render() {
        this.ref.detectChanges();
    }

    public async login() {
        if (!this.password) return;
        this.loading = true;
        this.render();

        let res = await wiz.call('verify', { password: this.password });
        this.loading = false;

        if (res.code === 200) {
            this.unlocked = true;
        } else {
            this.error = '비밀번호가 올바르지 않습니다.';
            this.password = '';
        }
        this.render();
    }

    public onKey(e: KeyboardEvent) {
        if (e.key === 'Enter') this.login();
    }
}

export default PageHomeComponent;